"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _I18n = _interopRequireDefault(require("I18n"));

var STATES = (0, _keyMirror.default)({
  NOT_REQUESTED: null,
  REQUEST_SUBMITTED: null,
  SUCCESS: null,
  ERROR: null
});

var RequestState =
/*#__PURE__*/
function () {
  function RequestState() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : STATES.NOT_REQUESTED;
    var message = arguments.length > 1 ? arguments[1] : undefined;
    (0, _classCallCheck2.default)(this, RequestState);
    this.state = state;
    this.message = message;
    this.lastChanged = _I18n.default.moment.utc(); // Make immutable.

    Object.freeze(this);
  }

  (0, _createClass2.default)(RequestState, [{
    key: "withMessage",
    value: function withMessage(message) {
      return new RequestState(this.state, message);
    }
  }, {
    key: "isNotRequested",
    value: function isNotRequested() {
      return this.state === STATES.NOT_REQUESTED;
    }
  }, {
    key: "isPending",
    value: function isPending() {
      return this.state === STATES.REQUEST_SUBMITTED;
    }
  }, {
    key: "isSuccessful",
    value: function isSuccessful() {
      return this.state === STATES.SUCCESS;
    }
  }, {
    key: "isFailed",
    value: function isFailed() {
      return this.state === STATES.ERROR;
    }
  }, {
    key: "shouldBeRequested",
    value: function shouldBeRequested() {
      return this.isNotRequested() || this.isFailed();
    }
  }, {
    key: "shouldShowLoader",
    value: function shouldShowLoader() {
      return this.isNotRequested() || this.isPending();
    }
  }]);
  return RequestState;
}();

var _default = {
  STATES: STATES,
  RequestState: RequestState,

  get NOT_REQUESTED() {
    return new RequestState(STATES.NOT_REQUESTED);
  },

  get REQUEST_SUBMITTED() {
    return new RequestState(STATES.REQUEST_SUBMITTED);
  },

  get SUCCESS() {
    return new RequestState(STATES.SUCCESS);
  },

  get ERROR() {
    return new RequestState(STATES.ERROR);
  }

};
exports.default = _default;
module.exports = exports.default;